// 保养提交列表
import request from '@/utils/request'
export const pageListApi = (data) => {
    return request({
        url: 'MaintenanceTasks/List',
        method: 'post',
        data
    })
}

export const auditApi = (data) => {
    return request({
        url: 'MaintenanceTasks/toExamine',
        method: 'post',
        data
    })
}

export const duplicateMonthListApi = (data) => {
    return request({
        url: 'DeviceListUser/duplicateMonthList',
        method: 'post',
        data
    })
}

export const duplicateMonthFlagApi = (data) => {
    return request({
        url: 'DeviceListUser/duplicateMonthFlag',
        method: 'post',
        data
    })
}